import React, { useContext, useRef } from "react";
import getImagePath from "helpers/get-image-path";
import VariantList from "../variant-list";
import {
  knifeImg, knife, knifeSelected, list, knifeImgWrap, knifeVariants,
  knifeSmall
} from "./style.mod.scss";
import ProductContext from "services/product-context";
import { Link } from "gatsby";
import { trackViewItemList } from "helpers/analytics";
import useTrackVisibility from "hooks/useTrackVisibility";

const KnifeVariants = (props) => {
  const { variants, currentVariant } = props;
  const { handle } = useContext(ProductContext);
  const listRef = useRef(null);

  const onVisible = () => {
    trackViewItemList({
      title: currentVariant?.store?.productTitle,
      products: variants,
      id: variants?._key
    });
  };

  useTrackVisibility(listRef, onVisible, { threshold: 0.3 });

  return <><ul className={`${list} knife-list`} ref={listRef}>
    {variants.map((variant) => {

      const alt = variant?.variantIcon?.alt?.replace("Olav ", "Olavson ");
      return (
        <li
          key={variant.id}
          className={`${knife} ${currentVariant.id === variant.id ? knifeSelected : ""} ${(variants.length < 4) ? knifeSmall : ""}`}
        >
          <Link to={`/products/${handle}/${variant.handle.current}`} state={{ preserveScroll: true }}>
            <div className={knifeImgWrap}>
              <img className={knifeImg} src={getImagePath(variant?.variantIcon)} alt={alt} />
            </div>
          </Link>
        </li>);
    }
    )}
  </ul>
  <VariantList
    variants={[{
      id: currentVariant?.id, image: currentVariant?.variantIcon, handle: currentVariant?.handle?.current
    }]}
    isSelected={false}
    className={knifeVariants}
  />

  <h4>{currentVariant.title}</h4>
  <hr></hr>
  <p>{currentVariant.woodDescription}</p>
  </>;
};

export default KnifeVariants;
